import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Fab } from "@material-ui/core";
import CheckIcon from '@material-ui/icons/Check';
import ExitIcon from '@material-ui/icons/Clear';
import React from 'react';

export type CustomDialogProps = {
    title: string,
    message: string,
    handleClose: any,
    handleOk: any,
    open: boolean,
}

export function CustomDialog(props: CustomDialogProps) {
    return (
        <Dialog
            open={props.open}
            onClose={props.handleClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle id="alert-dialog-title">{props.title}</DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-description">
                    {props.message}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Fab onClick={props.handleOk}>
                    <CheckIcon style={{ width: '2rem', height: '2rem' }} color="primary" titleAccess="Conferma"  />
                </Fab>
                <Fab onClick={props.handleClose}>
                    <ExitIcon style={{ width: '2rem', height: '2rem' }} color="secondary" titleAccess="Chiudi"  />
                </Fab>
            </DialogActions>
        </Dialog>)
}